import * as yup from "yup";

export const schema = (t) => {
  return yup
    .object({
      username: yup
        .string()
        .required(t("login.input.username.validations.emptyText")),
      password: yup
        .string()
        .required(t("login.input.password.validations.emptyText")),
    })
    .required();
};
